import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function FAQIcon(props) {
  return (
    <SvgIcon viewBox="0 0 61 60" {...props}>
      <title>FAQ</title>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.5725 20.749L58.2275 25.4615L56.47 41.7115L51.06 42.899L47.915 52.2715L40.5325 43.294L27.4725 43.074L25.905 37.064L29.8575 32.1465L36.8475 32.4515L40.5725 20.749ZM20.886 6.25024L38.546 11.0877L33.9835 28.5752L28.1235 28.3202L21.2335 38.2352L16.381 28.4002L4.98602 27.2102L3.22852 10.9627L20.886 6.25024Z"
        />
      </g>
    </SvgIcon>
  );
}

export default FAQIcon;
